export default __webpack_public_path__ + "static/media/fl-icon-28-dark.38f7d4b8.svg";